import { Column, ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";

export class CollapsibleColumn extends Column {
    static get $name() {
      return "CollapsibleColumn";
    }

    static get type() {
      return WIDGET_KEYS.collapsibleColumn;
    }

    static get defaults() {
      return {
        collapsible: true,
        sealed: true,
      };
    }

    applyState(state) {
      super.applyState(state);
      /* Issue: If state is restored from StateProvider in budget grid then correct collapsed icon state is displayed
      If State is applied to widget by using `state` key in widget instance then incorrect collapsed icon state is dislayed
      Fix: We are triggering `collapsible` setter again after applying column state. By doing so it will reinitialize the header widgets. */
      const collapsibleState = this.collapsible;
      this.collapsible = collapsibleState;
    }
}

ColumnStore.registerColumnType(CollapsibleColumn);